export const AlnaturaTheme = {
  name: 'Alnatura Theme',
  themeId: 'alnatura',
  colors: {
    brand: {
      primary: {
        100: '#8B254C'
      },
      secondary: {
        100: '#631a36'
      },
      accent: {
        100: '#8B254C'
      },
      alternative: {
        100: '#8B254C'
      }
    }
  },
  backgrounds: {
    tile: '#8B254C'
  }
};